import React from 'react'
import Button from './button'
import { useMessage } from '../lib/message'
import Badge from './badge'
import Stack from './stack'

interface IMessageProps extends React.HTMLProps<HTMLDivElement> {
  title: string
  id: string
  duration?: number
  variant?: 'default' | 'primary' | 'success' | 'warning'
}

const Message: React.FC<IMessageProps> = ({
  title,
  id,
  duration = 5000,
  variant,
  ...rest
}) => {
  const { deleteMessage } = useMessage()

  React.useEffect(() => {
    setTimeout(() => {
      // eslint-disable-next-line no-unused-expressions
      document.getElementById('message-delete-button')?.click()
    }, duration)
  }, [duration])

  return (
    <div className='message' {...rest}>
      <Stack align='center'>
        <Badge variant={variant} dot>
          <span />
        </Badge>
        <h4>{title}</h4>
      </Stack>

      <Button
        style={{ display: 'none' }}
        id='message-delete-button'
        onClick={() => deleteMessage(id)}
      >
        Close
      </Button>
    </div>
  )
}

export default Message
